import React, { forwardRef } from 'react';
import MediaCarousel, { MediaCarouselProps } from './MediaCarousel';
import ArtistCard, { Artist } from './ArtistCard';
import { Carousel3DHandle } from './Carousel3D';

interface ArtistsCarouselProps
  extends Omit<MediaCarouselProps<Artist>, 'items' | 'renderItem'> {
  artists: Artist[];
  selectedId?: string | null;
}

const ArtistsCarousel = forwardRef<Carousel3DHandle, ArtistsCarouselProps>(
  ({ artists, selectedId, ...props }, ref) => (
    <MediaCarousel
      ref={ref}
      items={artists}
      {...props}
      renderItem={(artist, index, selectedIndex, ctx) => (
        <ArtistCard
          ref={ctx.ref}
          artist={artist}
          selectedId={selectedId}
          isActive={index === selectedIndex}
          onSelect={props.onSelect}
          isMobile={ctx.isMobile}
          tiltEnabled={ctx.tiltEnabled}
        />
      )}
    />
  )
);

export default ArtistsCarousel;

